import { render, staticRenderFns } from "./PUserAccountRecovery.vue?vue&type=template&id=1f5fa124&"
import script from "./PUserAccountRecovery.vue?vue&type=script&lang=ts&"
export * from "./PUserAccountRecovery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports